import React from 'react'
import PropTypes from 'prop-types'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { stopEvent } from '@aytm/lib/common/func'
import Portal from '@aytm/lib/rfd-ui/components/basic/portal'

import '@aytm/lib/rfd-ui/styles/basic/light-box.scss'

export default class LightBox extends PureDataComponent {
  static propTypes = {
    onClose: PropTypes.func
  }

  constructor(...args) {
    super(...args)
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onClick = this.onClick.bind(this)
    this.mouseDownOnBackdrop = false
  }

  isBackdropNode(target) {
    return this.refLightBoxBackdrop == target || this.refLightBoxBackdropCenter == target
  }

  // Record only -- never close from here. The backdrop carries `overflow-y: auto`, so it is its
  // own scroll container, and a mousedown on its scrollbar reports the backdrop as the event
  // target. Closing on mousedown therefore dismissed the dialog the moment anyone grabbed the
  // scrollbar, which is reachable on any viewport short enough to make the content overflow.
  onMouseDown(event) {
    this.mouseDownOnBackdrop = this.isBackdropNode(event.target)
  }

  // A scrollbar interaction emits mousedown + mouseup but never `click`, so keying the close on
  // `click` ignores it without having to measure the scrollbar. Measuring would not work anyway:
  // overlay scrollbars (macOS default) occupy no layout width, so the usual
  // `offsetX > clientWidth` test never fires there.
  //
  // The remembered mousedown target additionally stops a drag that STARTED inside the dialog and
  // released on the backdrop from closing it -- `click` fires on the common ancestor, which is
  // the backdrop.
  onClick(event) {
    const { onClose, fullSize } = this.props
    const startedOnBackdrop = this.mouseDownOnBackdrop
    this.mouseDownOnBackdrop = false
    if ('function' == typeof onClose && !fullSize && startedOnBackdrop && this.isBackdropNode(event.target)) {
      stopEvent(event)
      onClose()
      return false
    }
    return true
  }

  render() {
    const { onClose, children, fullSize, background, className, ...otherProps } = this.props

    return (
      <Portal>
        <div
          className={`rfd-ui-light-box ${className ? className : ''}`}
          onMouseDown={this.onMouseDown}
          onClick={this.onClick}
          ref={this.saveRef('LightBoxBackdrop')}
          style={{ backgroundColor: background }}
          {...otherProps}
        >
          <div
            className="rfd-ui-light-box-center"
            onMouseDown={this.onMouseDown}
            onClick={this.onClick}
            ref={this.saveRef('LightBoxBackdropCenter')}
          >
            <div className="rfd-ui-light-box-center-content">{children}</div>
          </div>
        </div>
      </Portal>
    )
  }
}
